(() => {
  const ROOT_ATTR = 'data-pfh';
  const MOTION_ATTR = 'data-pfh-motion';
  const RETRY_MS = 80;
  const RETRY_MAX = 40;

  const STATIC_ATTR = 'data-pfh-static';

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const showStatic = (root) => {
    if (root) root.setAttribute(STATIC_ATTR, '');
  };

  const prepHero = (hero, desktop) => {
    const title = hero.querySelector('[data-pfh-hero-title]');
    const items = hero.querySelectorAll('[data-pfh-hero-item]');
    const media = hero.querySelector('[data-pfh-hero-media]');
    gsap.set(hero, {
      autoAlpha: 0,
      y: 40,
      scale: 0.97,
      transformOrigin: '50% 80%',
      force3D: true
    });
    if (title) gsap.set(title, { opacity: 0, y: 20, x: desktop ? -20 : 0 });
    if (items.length) gsap.set(items, { opacity: 0, y: 16, x: desktop ? -14 : 0 });
    if (media) {
      gsap.set(media, {
        opacity: 0,
        y: 16,
        x: desktop ? 32 : 0,
        scale: 0.94,
        transformOrigin: '50% 50%',
        force3D: true
      });
    }
    return { title, items, media };
  };

  const playHero = (hero, parts) => {
    const tl = gsap.timeline({
      defaults: { ease: 'power3.out' },
      scrollTrigger: {
        trigger: hero,
        start: 'top 92%',
        once: true,
        toggleActions: 'play none none none'
      }
    });

    tl.to(hero, { autoAlpha: 1, y: 0, scale: 1, duration: 0.85 });
    if (parts.title) tl.to(parts.title, { opacity: 1, y: 0, x: 0, duration: 0.75 }, '-=0.2');
    if (parts.items.length) {
      tl.to(parts.items, { opacity: 1, y: 0, x: 0, duration: 0.65, stagger: 0.12 }, '-=0.45');
    }
    if (parts.media) tl.to(parts.media, { opacity: 1, y: 0, x: 0, scale: 1, duration: 0.85 }, '-=0.55');
  };

  const destroyMotion = (root) => {
    if (!root) return;
    if (root._pfhRetry) {
      window.clearTimeout(root._pfhRetry);
      root._pfhRetry = null;
    }
    if (root._pfhCtx) {
      root._pfhCtx.revert();
      root._pfhCtx = null;
    }
    root.removeAttribute(MOTION_ATTR);
    root.removeAttribute(STATIC_ATTR);
  };

  const setupMotion = (root, attempt) => {
    if (!root || root.hasAttribute(MOTION_ATTR)) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      if ((attempt || 0) < RETRY_MAX) {
        root._pfhRetry = window.setTimeout(() => setupMotion(root, (attempt || 0) + 1), RETRY_MS);
        return;
      }
      showStatic(root);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    if (typeof SplitText !== 'undefined') gsap.registerPlugin(SplitText);
    root.setAttribute(MOTION_ATTR, '');

    if (prefersReducedMotion()) {
      showStatic(root);
      return;
    }

    const header = root.querySelector('[data-pfh-header]');
    const tag = root.querySelector('[data-pfh-tag]');
    const title = root.querySelector('[data-pfh-title]');
    const subtitle = root.querySelector('[data-pfh-subtitle]');
    const heroes = root.querySelectorAll('[data-pfh-hero]');
    const cards = root.querySelectorAll('[data-pfh-card]');
    if (!header && !heroes.length && !cards.length) return;

    root._pfhCtx = gsap.context(() => {
      if (tag) gsap.set(tag, { autoAlpha: 0, y: 16 });
      if (title) gsap.set(title, { autoAlpha: 0 });
      if (subtitle) gsap.set(subtitle, { autoAlpha: 0, y: 16 });

      const desktop = window.matchMedia('(min-width: 750px)').matches;
      heroes.forEach((hero) => {
        playHero(hero, prepHero(hero, desktop));
      });

      if (cards.length) {
        gsap.set(cards, { autoAlpha: 0, y: 28 });
        ScrollTrigger.batch(cards, {
          start: 'top 88%',
          once: true,
          interval: 0.12,
          batchMax: 3,
          onEnter: (batch) => {
            gsap.to(batch, {
              autoAlpha: 1,
              y: 0,
              duration: 0.85,
              stagger: 0.16,
              ease: 'power3.out',
              overwrite: true
            });
          }
        });
      }

      if (!header) return;

      const playIntro = (words) => {
        const tl = gsap.timeline({
          defaults: { ease: 'power3.out' },
          scrollTrigger: {
            trigger: header,
            start: 'top 78%',
            once: true,
            toggleActions: 'play none none none'
          }
        });

        if (tag) tl.to(tag, { autoAlpha: 1, y: 0, duration: 0.7 }, 0);
        if (words && words.length) {
          tl.set(title, { autoAlpha: 1 }, 0.12);
          tl.from(words, { yPercent: 140, duration: 1.05, stagger: 0.1 }, 0.12);
        } else if (title) {
          tl.to(title, { autoAlpha: 1, y: 0, duration: 0.8 }, 0.12);
        }
        if (subtitle) tl.to(subtitle, { autoAlpha: 1, y: 0, duration: 0.75 }, 0.4);
        return tl;
      };

      if (title && typeof SplitText !== 'undefined') {
        SplitText.create(title, {
          type: 'words',
          mask: 'words',
          wordsClass: 'pfh-word',
          aria: 'auto',
          autoSplit: true,
          onSplit(self) {
            return playIntro(self.words);
          }
        });
      } else {
        if (title) gsap.set(title, { y: 16 });
        playIntro();
      }
    }, root);
  };

  const scan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach((root) => setupMotion(root, 0));
  };

  const rescan = () => {
    document.querySelectorAll(`[${ROOT_ATTR}]`).forEach(destroyMotion);
    scan();
    if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', rescan);
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target && event.target.querySelector(`[${ROOT_ATTR}]`);
    if (root) destroyMotion(root);
  });
})();
